import { IdleDetailing, IWorkDetailRequestBody } from "@baseTypes/service/dashboard/IWorksDashboardService";
import { ApiState } from "@baseTypes/baseType";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createThunk } from "../../crops/selector";
import { dashboardURL } from "@utils/utils";
import { applyExtraReducer } from "../../../weather";

export type IdlesSliceState = {
    data: IdleDetailing
} & ApiState

const initialState: IdlesSliceState = {
    isApiLoading: false,
    apiError: undefined,
    data: []
}

const fetchIdleDetails = createThunk<IdleDetailing, IWorkDetailRequestBody, IWorkDetailRequestBody>()({
    url: dashboardURL('idleDetail'),
    method: "POST"
}, (payload, url) => ({url, data: payload}))

const idlesSlice = createSlice({
    name: 'idlesSlice',
    initialState,
    reducers: {},
    extraReducers: builder => {
        applyExtraReducer(builder, fetchIdleDetails, {
            fulfillReducer: (state: IdlesSliceState, action: PayloadAction<IdleDetailing>) => {
                state.data = action.payload
            }
        })
    }
})

export const actions = { ...idlesSlice.actions, fetchIdleDetails }

export default idlesSlice.reducer